namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_DiscForm {
    }

    export class Report_1201_DiscForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1201_Disc';
    }
}
